import { useState } from 'react';
import { faqs, siteName } from '@/mocks/chigua';

export default function Faq() {
  const [openId, setOpenId] = useState<string | null>('q1');

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };

  return (
    <section id="faq" className="scroll-mt-24 bg-background-100 py-12 md:py-16">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <div className="mx-auto w-full max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <p className="flex items-center justify-center gap-1.5 text-xs font-semibold tracking-widest text-primary-600">
            <i className="ri-questionnaire-line"></i> 常见问题
          </p>
          <h2 className="heading-font mt-2 text-2xl font-extrabold text-foreground-950 md:text-3xl">
            关于 {siteName}，你可能想问
          </h2>
        </div>

        <div className="mt-8 space-y-3">
          {faqs.map((f) => {
            const open = openId === f.id;
            return (
              <div
                key={f.id}
                className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                  open ? 'border-primary-200' : 'border-secondary-100'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenId(open ? null : f.id)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left md:px-6"
                >
                  <span className="flex items-start gap-3">
                    <span
                      className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                        open ? 'bg-primary-500 text-background-50' : 'bg-secondary-100 text-secondary-800'
                      }`}
                    >
                      {open ? '?' : '?'}
                    </span>
                    <h3 className="text-sm font-semibold text-foreground-900 md:text-base">{f.q}</h3>
                  </span>
                  <i
                    className={`ri-arrow-down-s-line shrink-0 text-lg text-foreground-400 transition-transform duration-200 ${
                      open ? 'rotate-180 text-primary-500' : ''
                    }`}
                  ></i>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-4 pb-5 pl-[3.25rem] text-xs leading-relaxed text-foreground-600 md:px-6 md:pl-16 md:text-sm">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}